// $( document ).ready(function() {
//     var main_total=0;
//   	var comp_total=0;

//       $('.bundle_1 .p_bundle_price').each(function() {
//           main_total = main_total + parseInt($(this).attr("data-price"));
//           comp_total = comp_total + parseInt($(this).attr("data-comp-price"));
//       });

//   	var mult = main_total * 0.075; // gives the value for subtract from main value
// 	var disconted_total = main_total - mult;

//   console.log("discont =>"+ mult);
//   console.log("disconted_total =>"+ disconted_total);

// //   $(".bundle_1 .p_bundle_discount .money").text(Shopify.formatMoney(comp_total, $('body').data('money-format')));
// //   $(".bundle_1 .p_bundle_final_price .money").text(Shopify.formatMoney(main_total, $('body').data('money-format')));
//   $(".bundle_1 .p_bundle_discount .money").text(Shopify.formatMoney(main_total, $('body').data('money-format')));
//   $(".bundle_1 .p_bundle_final_price .money").text(Shopify.formatMoney(disconted_total, $('body').data('money-format')));
// });
  //============update price on bumdle var change.... 
// $('.bundle-variant-dropdown').on('change', function() {
//     var selectprice = $(this).find(":checked").attr("data-main-price");
//     console.log("selectprice", selectprice);
//     $(this).parents("div.p_bundle_list").find(".p_regular_price").text(Shopify.formatMoney(selectprice, $("body").data("money-format")))
// });
$(document).on("change", ".bundle-variant-dropdown", function () {
  var varImg = $(this).find("option:selected").attr("data-variant-image");
  var main_price_js = $(this).find("option:selected").attr("data-main-price");
  var compare_price_js = $(this)
    .find("option:selected")
    .attr("data-comp-price");

  var VarId = $(this).find("option:selected").attr("value");

  if (varImg != "") {
    $(this)
      .closest(".p_bundle_list")
      .find(".p_bundle_img")
      .find("img")
      .attr("src", varImg);
  }

  if (main_price_js != "") {
    if (main_price_js == 0) {
      $(this)
        .closest(".p_bundle_list")
        .find(".p_bundle_price")
        .find(".p_regular_price")
        .find(".money")
        .text("Free");
    } else {
      $(this)
        .closest(".p_bundle_list")
        .find(".p_bundle_price")
        .find(".p_regular_price")
        .find(".money")
        .text(
          Shopify.formatMoney(main_price_js, $("body").data("money-format"))
        );
    }
    $(this)
      .closest(".p_bundle_list")
      .find(".p_bundle_price")
      .attr("data-price", main_price_js);
  }

  if (compare_price_js != "") {
    $(this)
      .closest(".p_bundle_list")
      .find(".p_bundle_price")
      .find(".p_old_price")
      .find(".money")
      .text(
        Shopify.formatMoney(compare_price_js, $("body").data("money-format"))
      );
    $(this)
      .closest(".p_bundle_list")
      .find(".p_bundle_price")
      .attr("data-comp-price", compare_price_js);
  }

  if (VarId != "") {
    $(this).closest(".p_bundle_list").attr("data-id", VarId);
  }

  var main_total = 0;
  var comp_total = 0;

  $(".bundle_1 .p_bundle_price").each(function () {
    main_total = main_total + parseInt($(this).attr("data-price"));
    comp_total = comp_total + parseInt($(this).attr("data-comp-price"));
  });

  $(".bundle_1 .p_bundle_discount .money").text(
    Shopify.formatMoney(comp_total, $("body").data("money-format"))
  );
  $(".bundle_1 .p_bundle_final_price .money").text(
    Shopify.formatMoney(main_total, $("body").data("money-format"))
  );
});

$(document).on("click", ".b_add_to_cart", function () {
  let arr = [];
  var timestamp = Math.round(new Date().getTime() / 1000);
  $(this)
    .closest(".accordion")
    .find(".p_bundle_list")
    .each(function () {
      console.log($(this).attr("data-id"));
      var vId = $(this).attr("data-id");

      if ($(this).hasClass("free_initials")) {
        var initials = $(this).find(".3Free_inittials").val();
        arr.push({
          id: vId,
          quantity: 1,
          properties: {
            _bundle: "bundle-" + timestamp,
            free_intials: initials,
          },
        });
      } else {
        arr.push({
          id: vId,
          quantity: 1,
          properties: { _bundle: "bundle-" + timestamp },
        });
      }
    });

  let formData = { items: arr };
  console.log(formData);

  fetch("/cart/add.js", {
    body: JSON.stringify(formData),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "xmlhttprequest",
    },
    method: "POST",
  })
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      /* yay! our products were added - do something here to indicate to the user */

      console.log("added=>" + res);
      location.href = "/cart";
    })
    .catch((err) => {
      /* uh oh, we have error. */
      console.error(err);
    });
});

function refreshCart(cart) {
  $(".cart_count").empty();
  $cartBtn = $(".cart_count");
  var value = $cartBtn.text() || "0";
  var cart_items_html = "";
  var cart_discounts_html = "";
  var cart_action_html = "";
  var cart_savings_html = "";
  var $cart_form = $("[data-cart-form]");
  var productHasSale = false;
  var productCompareAtPrice = 0;
  var productFinalPrice = 0;

  $cart_form.data("total-discount", cart.total_discount);

  $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

  if (cart.item_count == 0) {
    $(".js-empty-cart__message").removeClass("hidden");
    $cart_form.addClass("hidden");
  } else {
    $(".js-empty-cart__message").addClass("hidden");
    $cart_form.removeClass("hidden");

    var total_saving = 0; // adding counter variables for total cart savings
    var saving = 0;

    $.each(cart.items, function (index, item) {
      var itemDiscounts = item.discounts;
      var discountMessage = "";
      var bundle_timestamp = "";

      for (i = 0; i < itemDiscounts.length; i++) {
        var amount = Shopify.formatMoney(
          itemDiscounts[i].amount,
          $("body").data("money-format")
        );
        var title = itemDiscounts[i].title;
        discountMessage =
          '<p class="notification-discount meta">' + title + "</p>";
      }
      var line_id = index + 1;

      cart_items_html +=
        '<li class="mini-cart__item clearfix" data-cart-item data-line-id="' +
        line_id +
        '" data-variant-id="' +
        item.id +
        '">' +
        '<a href="' +
        item.url +
        '">';
      if (item.image) {
        cart_items_html +=
          '<div class="cart_image">' +
          '<img src="' +
          item.image.replace(/(\.[^.]*)$/, "_compact$1").replace("http:", "") +
          '" alt="' +
          htmlEncode(item.title) +
          '" />' +
          "</div></a>";
      }

      cart_items_html +=
        '<div class="mini-cart__item--content"><div class="mini-cart__item__title"><div class="item_title"><a href="' +
        item.url +
        '">' +
        item.title +
        "</a></div>";

      if (item.properties) {
        $.each(item.properties, function (title, value) {
          if (title.charAt(0) != "_") {
            if (value) {
              cart_items_html +=
                '<div class="line-item">' + title + ": " + value + " </div>";
            }
          } else {
            if (title === "_bundle") {
              bundle_timestamp = value;
            }
          }
        });
      }

      cart_items_html += '<strong class="right price">';

      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        url: "/products/" + item.handle + ".js",
        success: function (data) {
          // If item has more than one variant, need to make sure we are pulling data from the correct variant
          if (data.variants) {
            var itemVariants = data.variants;
            if (itemVariants.length > 1) {
              for (v = 0; v < itemVariants.length; v++) {
                if (itemVariants[v].id == item.id) {
                  var data = itemVariants[v];
                }
              }
            }
          }

          // If compare at price exists then item is on sale
          if (data.compare_at_price) {
            if (data.compare_at_price > data.price) {
              productHasSale = true;
              productCompareAtPrice = data.compare_at_price;
              productFinalPrice = data.price;
            }
          } else {
            // Check required for non-sale items
            productHasSale = false;
          }
        },
      });

      if (productHasSale == true) {
        //puts the slash through the old item price
        var itemPrice =
          Shopify.formatMoney(
            productFinalPrice,
            $("body").data("money-format")
          ) +
          ' </span><span class="money was_price">' +
          Shopify.formatMoney(
            productCompareAtPrice,
            $("body").data("money-format")
          ) +
          "</span>";
        cart_items_html +=
          '<span class="money sale">' + itemPrice + "</strong>";

        // Total savings
        saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
        total_saving = saving + total_saving;
      } else {
        if (item.price > item.final_price) {
          //puts the slash through the old item price
          var itemPrice =
            Shopify.formatMoney(
              item.final_price,
              $("body").data("money-format")
            ) +
            ' </span><span class="money was_price">' +
            Shopify.formatMoney(item.price, $("body").data("money-format")) +
            "</span>";
          cart_items_html +=
            '<span class="money sale">' + itemPrice + "</strong>";
        } else {
          var itemPrice = Shopify.formatMoney(
            item.price,
            $("body").data("money-format")
          );
          cart_items_html +=
            '<span class="money">' + itemPrice + "</span></strong>";
        }
      }

      if (item.price > item.final_price) {
        cart_items_html += discountMessage;
      }

      cart_items_html += '<div class="left product-quantity-box">';
      cart_items_html +=
        '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
      cart_items_html +=
        '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' +
        item.id +
        '" value="' +
        item.quantity +
        '" data-cart-quantity-input="mini-cart" />';
      cart_items_html +=
        '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
      cart_items_html += "</div></div></div>";
      //         cart_items_html += '<a href="/cart/change?line=' + line_id + '&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="' + line_id + '" data-remove-item="mini-cart"><span class="remove-icon"></span></a>';
      if (bundle_timestamp != "") {
        cart_items_html +=
          '<a href="/cart/change?line=' +
          line_id +
          '&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn muti_remove" data-product_id="' +
          item.id +
          '" data-timestamp="' +
          bundle_timestamp +
          '" data-line-id="' +
          line_id +
          '"><span class="remove-icon"></span></a>';
      } else {
        cart_items_html +=
          '<a href="/cart/change?line=' +
          line_id +
          '&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="' +
          line_id +
          '" data-remove-item="mini-cart"><span class="remove-icon"></span></a>';
      }
    });

    var cartDiscounts = cart.cart_level_discount_applications;
    var cartDiscountMessage = "";

    for (i = 0; i < cartDiscounts.length; i++) {
      var amount = Shopify.formatMoney(
        cartDiscounts[i].total_allocated_amount,
        $("body").data("money-format")
      );
      var title = cartDiscounts[i].title;

      cart_discounts_html +=
        '<span class="cart_discounts--title">' + title + "</span>";
      cart_discounts_html += '<span class="cart_discounts--price">';
      cart_discounts_html +=
        '-<span class="money">' + amount + "</span></span>";
    }

    cart_action_html +=
      '<span class="right"><span class="money">' +
      Shopify.formatMoney(cart.total_price, $("body").data("money-format")) +
      "</span></span>" +
      "<span>" +
      Shopify.translation.cart_subtotal_text +
      "</span>";
    total_saving = total_saving + cart.total_discount;
    if (Shopify.theme_settings.display_savings && total_saving > 0) {
      cart_savings_html =
        '<span class="right"><span class="money">' +
        Shopify.formatMoney(total_saving, $("body").data("money-format")) +
        "</span></span>" +
        "<span>" +
        Shopify.translation.cart_savings_text +
        "</span>";
    } else {
      cart_savings_html = "";
    }
  }

  $(".js-cart_items").html(cart_items_html);
  $(".js-cart_discounts").html(cart_discounts_html);
  $(".js-cart_subtotal").html(cart_action_html);
  $(".js-cart_savings").html(cart_savings_html);

  // Converting the currencies
  if (Currency.show_multiple_currencies) {
    currencyConverter.convertCurrencies();
  }
}

$(document).on("click", "a.muti_remove", function (e) {
  e.preventDefault();

  var toRemove = "";
  var mainpdptimestamp = $(this).attr("data-timestamp");

  $("a.muti_remove").each(function (key, value) {
    var cartItem = {
      lineID: $(this).parents("[data-cart-item]").data("line-id"),
      variantID: $(this).parents("[data-cart-item]").data("variant-id"),
      quantity: 0,
      parentCartForm: $(this).parents("[data-cart-form]"),
      totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
      $element: $(this).parents("[data-cart-item]"),
    };
    var crntptimestamp = $(this).data("timestamp");
    if (crntptimestamp == mainpdptimestamp) {
      if (cartItem.parentCartForm.data("cart-form") === "cart-template") {
        $(this).parents("[data-cart-item]").find("input").val("0");
        cartItem.parentCartForm.submit();
      }

      if (cartItem.parentCartForm.data("cart-form") === "mini-cart") {
        $(this).parents("[data-cart-item]").find("input").val("0");
      }
      toRemove += "updates[" + cartItem.variantID + "]=0&";
    }
  });

  var paramsup = {
    type: "POST",
    url: "/cart/update.js",
    dataType: "json",
    data: toRemove.substring(0, toRemove.length - 1),
    success: function (data) {
      console.log(data);
      refreshCart(data);
    },
    error: function (e, t) {},
    complete: function () {
      //             location.reload();
    },
  };

  if (!$("body").hasClass("cart")) {
    $.ajax(paramsup);
  }
});

const checkDiv = setInterval(() => {
  if (
    document.querySelectorAll(
      ".purchase-details__buttons.purchase-details__spb--false"
    ).length > 0 &&
    document.querySelectorAll(".add_to_cart.klaviyo-bis-trigger").length > 0
  ) {
    if (
      document
        .querySelector(
          ".purchase-details__buttons.purchase-details__spb--false"
        )
        .classList.contains("product-is-unavailable")
    ) {
      document.querySelector(".add_to_cart.klaviyo-bis-trigger").style.display =
        null;
    } else {
      document.querySelector(".add_to_cart.klaviyo-bis-trigger").style.display =
        "none";
    }
  }
}, 100);
